/**
 * Warstwa API: FUNKCJE ADMINISTRACYJNE MODUŁU ZGŁOSZEŃ (P13b, polecenie właściciela 2026-10-01).
 *
 * Trasy backendu (`TicketModulesController.FunkcjeAdmina.cs`, `api/ticket-modules`):
 *  • `GET {id}/funkcje-admina`                     — stan funkcji „Konfiguracja filtrów domen” i „Konfiguracja raportów”
 *                                                     w module: przełącznik, „dyrektor automatycznie”, dyrektor z plakietką,
 *                                                     osoby dopisane (czynne / wygasłe z powodem) — tylko administrator,
 *  • `PUT {id}/funkcje-admina/{kod}`               — `{ wlaczona?, dyrektorAutomatycznie? }` (pole nieobecne = bez zmian),
 *  • `POST {id}/funkcje-admina/{kod}/osoby`        — `{ userId }` (400 ze zdaniem: konto nieczynne / osoba spoza modułu),
 *  • `DELETE {id}/funkcje-admina/{kod}/osoby/{userId}`,
 *  • `GET moje-funkcje-admina?kod=<kod modułu>`    — które przyciski funkcji pokazać zalogowanemu w kolejce modułu
 *                                                     (`{ filtrDomen, konfiguracjaRaportow }` — liczy serwer).
 *
 * Każda zmiana rozgłasza `FunkcjeModuluZmiana` → most NotificationContext → zdarzenie okna `funkcje-modulu-zmiana`.
 */
export const ZDARZENIE_FUNKCJI_MODULU = "funkcje-modulu-zmiana";

export const KOD_FILTR_DOMEN = "FILTR_DOMEN";
export const KOD_KONFIGURACJA_RAPORTOW = "KONFIGURACJA_RAPORTOW";

export function attach(api) {
    return {
        getFunkcjeAdminaModulu: (moduleId) => api.get(`/ticket-modules/${moduleId}/funkcje-admina`),
        ustawFunkcjeAdminaModulu: (moduleId, kod, zmiana) =>
            api.put(`/ticket-modules/${moduleId}/funkcje-admina/${encodeURIComponent(kod)}`, zmiana),
        dodajOsobeFunkcjiAdmina: (moduleId, kod, userId) =>
            api.post(`/ticket-modules/${moduleId}/funkcje-admina/${encodeURIComponent(kod)}/osoby`, { userId }),
        usunOsobeFunkcjiAdmina: (moduleId, kod, userId) =>
            api.delete(`/ticket-modules/${moduleId}/funkcje-admina/${encodeURIComponent(kod)}/osoby/${userId}`),
        getMojeFunkcjeAdmina: (kodModulu) =>
            api.get("/ticket-modules/moje-funkcje-admina", { params: { kod: kodModulu || "itsm" } }),
    };
}
